import React from 'react';
import { FaArrowLeft } from "react-icons/fa";
import ActionDropdown from '../Utils/ActionDropdown';
import ImportExportButtons from '../Tools/ImportExportButtons';

function HeaderCard({ title, text, ajout, path, addNew, goBack, exportProps, dropdownActions = [] }) {

  const addElement = () => {
    if (path) {
      window.location.href = path;
    } else {
      addNew && addNew();
    }
  };

  // Dropdown actions
  const actions = [
    ...dropdownActions,
      exportProps && {
      label: "Importer / Exporter",
      onClick: () => {},
      custom: (
        <ImportExportButtons
          {...exportProps}
          importUrl={exportProps.importUrl}
          onImportSuccess={exportProps.onImportSuccess}
          dropdown={true}
        />
      )
    },
  ].filter(Boolean);

  return (
    <>
      <div className="flex flex-col md:flex-row justify-between items-center mb-6">
        <div className="text-start">
          <div className="mb-2">
            <h1 className="text-2xl font-bold flex items-center">
              {goBack && <small className="mr-4 text-gray-400 cursor-pointer" onClick={goBack}><FaArrowLeft /></small>}
              {title}
            </h1>
          </div>
          <div>
            <p className="leading-relaxed">{text}</p>
          </div>
        </div>
        <div className="flex justify-end items-center space-x-2">
          {ajout && (path || addNew) && (
            <button className="bg-[--color-primary] text-white hover:bg-[--color-primary] rounded-full btn flex items-center" onClick={addElement}>
              Ajouter {ajout}
            </button>
          )}
          {actions.length > 0 && (
            <ActionDropdown
              actions={actions.map(a => ({
                ...a,
                isCustom: !!a.custom,
                label: a.custom ? (
                  <div className="w-full">{a.custom}</div>
                ) : a.label,
                onClick: a.custom ? undefined : a.onClick,
              }))}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default HeaderCard;